import { z } from 'zod';

export const LocaleDTO = z.object({
    locale: z.string(),
});
